var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Divider',{attrs:{"dashed":""}},[_c('span',{staticClass:"divider-text"},[_vm._v("周期分项统计")])]),_c('Table',{attrs:{"stripe":"","data":_vm.agentBillList,"columns":_vm.tableColumns,"show-summary":"","summary-method":_vm.handleSummary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }